.flashItem {
  transition: height 0.5s ease;
  box-sizing: border-box;
  height: 0;
  overflow-y: hidden;
}
